// CC: extracted from threat-prevention.component.ts -> notifyOptionsPopup
import _ from 'lodash';
import {RouteService} from "../../../../../../services/routeService";
import {NotificationService} from "../../../../../../services/notificationService";
import {GeneralService} from "../../../../../../services/generalService";
import {DICTIONARY} from "../../../../../../dictionary";
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";


@Component({
	selector: 'notification-options-component',
	templateUrl: './notification-options.component.html',
})
export class NotificationOptionsComponent implements OnInit {
	@Input() mainRulePreset;
	@Input() isEmbedded = false;
	@Output() closeCb = new EventEmitter<void>();

	dic = DICTIONARY;
	_ = _;

	quarantineEmailNotificationPlaceholder = '[Inbound Shield] Threat detected for {{MAILBOX_EMAIL}}';
	quarantineEmailDigestNotificationPlaceholder = '[Inbound Shield] Threat detected for {{DETECTED_THREATS}} emails';
	releaseRequestSubjectPlaceholder = '[Inbound Shield] ({{COMPANY_NAME}}) {{RECIPIENT_EMAIL}} release request for email "{{EMAIL_SUBJECT}}"';

	notifyOptionsPopup;

	constructor(public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService) {
	}

	ngOnInit() {
		this.openNotifyOptions();
	}

	openNotifyOptions() {
		// CC: taken from threat-prevention.component.ts -> openNotifyOptions
		const notifyReviewerPeriods = {};
		_.forEach(this.dic.CONSTANTS.tpRule.notifyOptions, (periodName, periodKey) => {
			notifyReviewerPeriods[periodName] = this.mainRulePreset.notify_reviewer_periods.includes(periodName);
		});
		let notifyReviewerDailyHours = [];
		if (this.mainRulePreset.notify_reviewer_daily_hour) {
			notifyReviewerDailyHours = this.mainRulePreset.notify_reviewer_daily_hour.split(', ');
			for (let i = 0; i < notifyReviewerDailyHours.length; i++) {
				let formattedHour: any = new Date();
				formattedHour.setUTCHours(notifyReviewerDailyHours[i]);
				formattedHour = (formattedHour.getHours() < 10 ? '0' : '') + formattedHour.getHours();
				notifyReviewerDailyHours[i] = formattedHour;
			}
		}

		const notifyRecipientPeriods = {};
		_.forEach(this.dic.CONSTANTS.tpRule.notifyOptions, (periodName, periodKey) => {
			notifyRecipientPeriods[periodName] = this.mainRulePreset.notify_recipient_periods.includes(periodName);
		});
		let notifyRecipientDailyHours = [];
		if (this.mainRulePreset.notify_recipient_daily_hour) {
			notifyRecipientDailyHours = this.mainRulePreset.notify_recipient_daily_hour.split(', ');
			for (let i = 0; i < notifyRecipientDailyHours.length; i++) {
				let formattedHour: any = new Date();
				formattedHour.setUTCHours(notifyRecipientDailyHours[i]);
				formattedHour = (formattedHour.getHours() < 10 ? '0' : '') + formattedHour.getHours();
				notifyRecipientDailyHours[i] = formattedHour;
			}
		}

		let notifyReviewerDays = _.map(this.gs.daysArr, day => ({
			day: day,
			selected: this.mainRulePreset.notify_reviewer_days?.includes(day) || false
		}));

		const notifyRecipientDays = _.map(this.gs.daysArr, day => ({
			day: day,
			selected: this.mainRulePreset.notify_recipient_days?.includes(day) || false
		}));

		const tabs = {
			reviewer: 'Reviewer Notification',
			recipient: 'Recipient Notification',
			releaseRequest: 'Recipient Release Request Notification',
		};
		this.notifyOptionsPopup = {
			tabs,
			activeTab: tabs.reviewer,
			notifyReviewerPeriods,
			notifyReviewerDailyHours,
			notifyReviewerDays,
			notifyRecipientPeriods,
			notifyRecipientDailyHours,
			notifyRecipientDays,
			notifyRecipientEmailTitle: this.mainRulePreset.notify_recipient_email_title,
			notifyReviewerEmailTitle: this.mainRulePreset.notify_reviewer_email_title,
			notifyRecipientEmailDigestTitle: this.mainRulePreset.notify_recipient_email_digest_title,
			notifyReviewerEmailDigestTitle: this.mainRulePreset.notify_reviewer_email_digest_title,
			notifyRecipientPeriodText: this.mainRulePreset.notify_recipient_period_text,
			notifyRecipientAllowChangeTime: this.mainRulePreset.notify_recipient_allow_change_time,
			notifyRecipientAllowRequestRelease: this.mainRulePreset.notify_recipient_allow_request_release,
			requireRecipientReleaseRequestReason: this.mainRulePreset.recipient_request_release_reason_mandatory,
			notifyRecipientAllowRequestReleaseFrom: this.mainRulePreset.notify_recipient_allow_request_release_email_change_from,
			notifyRecipientAllowRequestReleaseEmail: this.mainRulePreset.notify_recipient_allow_request_release_email,
			notifyRecipientAllowRequestSubject: this.mainRulePreset.notify_release_request_subject,
			notifyRecipientShowLinkToWebapp: this.mainRulePreset.notify_recipient_show_link_to_webapp,
			notifyRecipientShowTagInfo: this.mainRulePreset.notify_recipient_show_tag_info,
			notifyReplyToEmail: this.mainRulePreset.notify_reply_to || '',
			isNotifyReviewerPeriodsError: false,
			isNotifyRecipientPeriodsError: false,
			show: true
		};
	}

	changeNotifyPeriod = () => {
		// CC: taken from threat-prevention.component.ts -> changeNotifyPeriod
		if (this.notifyOptionsPopup.changeNotifyPeriodInProcess) {
			return;
		}

		const isOneReviewerPeriodEnabled = _.find(this.notifyOptionsPopup.notifyReviewerPeriods, period => {
			return !!period;
		});
		const isOneRecipientPeriodEnabled = _.find(this.notifyOptionsPopup.notifyRecipientPeriods, period => {
			return !!period;
		});

		if (!isOneReviewerPeriodEnabled) {
			this.notifyOptionsPopup.isNotifyReviewerPeriodsError = true;
		}
		if (!isOneRecipientPeriodEnabled) {
			this.notifyOptionsPopup.isNotifyRecipientPeriodsError = true;
		}

		this.notifyOptionsPopup.isNotifyReviewerDailyHoursError = this.notifyOptionsPopup.notifyReviewerPeriods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !this.notifyOptionsPopup.notifyReviewerDailyHours.length;
		this.notifyOptionsPopup.isNotifyRecipientDailyHoursError = this.notifyOptionsPopup.notifyRecipientPeriods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !this.notifyOptionsPopup.notifyRecipientDailyHours.length;

		this.notifyOptionsPopup.isNotifyReviewerDaysError = this.notifyOptionsPopup.notifyReviewerPeriods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !_.some(this.notifyOptionsPopup.notifyReviewerDays, {selected: true});
		this.notifyOptionsPopup.isNotifyRecipientDaysError = this.notifyOptionsPopup.notifyRecipientPeriods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !_.some(this.notifyOptionsPopup.notifyRecipientDays, {selected: true});

		if (!isOneRecipientPeriodEnabled || !isOneReviewerPeriodEnabled || this.notifyOptionsPopup.isNotifyReviewerDailyHoursError || this.notifyOptionsPopup.isNotifyRecipientDailyHoursError || this.notifyOptionsPopup.isNotifyReviewerDaysError || this.notifyOptionsPopup.isNotifyRecipientDaysError) {
			return;
		}
		if (this.notifyOptionsPopup.notifyRecipientAllowRequestSubject && this.notifyOptionsPopup.notifyRecipientAllowRequestSubject.length > 200) {
			this.ns.showErrorMessage('Email title must be under 200 characters');
			return;
		}

		const notifyReviewerPeriodsArr = _.keys(_.pickBy(this.notifyOptionsPopup.notifyReviewerPeriods));
		const notifyRecipientPeriodsArr = _.keys(_.pickBy(this.notifyOptionsPopup.notifyRecipientPeriods));

		let notifyReviewerDailyHoursUTC = _.cloneDeep(this.notifyOptionsPopup.notifyReviewerDailyHours);
		for (let i = 0; i < notifyReviewerDailyHoursUTC.length; i++) {
			let formattedHour: any = new Date();
			formattedHour.setHours(notifyReviewerDailyHoursUTC[i]);
			formattedHour = (formattedHour.getUTCHours() < 10 ? '0' : '') + formattedHour.getUTCHours();
			notifyReviewerDailyHoursUTC[i] = formattedHour;
		}

		let notifyRecipientDailyHoursUTC = _.cloneDeep(this.notifyOptionsPopup.notifyRecipientDailyHours);
		for (let i = 0; i < notifyRecipientDailyHoursUTC.length; i++) {
			let formattedHour: any = new Date();
			formattedHour.setHours(notifyRecipientDailyHoursUTC[i]);
			formattedHour = (formattedHour.getUTCHours() < 10 ? '0' : '') + formattedHour.getUTCHours();
			notifyRecipientDailyHoursUTC[i] = formattedHour;
		}

		const selectedNotifyReviewerDays = _.map(
			_.filter(this.notifyOptionsPopup.notifyReviewerDays, {selected: true}),
			'day'
		);

		const selectedNotifyRecipientDays = _.map(
			_.filter(this.notifyOptionsPopup.notifyRecipientDays, {selected: true}),
			'day'
		);

		const ruleData = {
			type: this.dic.CONSTANTS.rulesTpAction.rule,
			action: 'options',
			data: {
				options: {
					notify_reviewer_periods: notifyReviewerPeriodsArr,
					notify_reviewer_daily_hour: notifyReviewerDailyHoursUTC.join(', '),
					notify_reviewer_days: selectedNotifyReviewerDays,
					notify_recipient_periods: notifyRecipientPeriodsArr,
					notify_recipient_daily_hour: notifyRecipientDailyHoursUTC.join(', '),
					notify_recipient_days: selectedNotifyRecipientDays,
					notify_recipient_period_text: this.notifyOptionsPopup.notifyRecipientPeriodText,
					notify_recipient_allow_request_release: this.notifyOptionsPopup.notifyRecipientAllowRequestRelease,
					recipient_request_release_reason_mandatory: this.notifyOptionsPopup.requireRecipientReleaseRequestReason,
					notify_recipient_allow_request_release_email: this.notifyOptionsPopup.notifyRecipientAllowRequestReleaseEmail,
					notify_recipient_allow_request_release_email_change_from: this.notifyOptionsPopup.notifyRecipientAllowRequestReleaseFrom,
					notify_recipient_allow_change_time: this.notifyOptionsPopup.notifyRecipientAllowChangeTime,
					notify_release_request_subject: this.notifyOptionsPopup.notifyRecipientAllowRequestSubject,
					notify_recipient_show_link_to_webapp: this.notifyOptionsPopup.notifyRecipientShowLinkToWebapp,
					notify_recipient_show_tag_info: this.notifyOptionsPopup.notifyRecipientShowTagInfo,
					notify_reply_to: this.notifyOptionsPopup.notifyReplyToEmail,
					notify_recipient_email_title: this.notifyOptionsPopup.notifyRecipientEmailTitle,
					notify_reviewer_email_title: this.notifyOptionsPopup.notifyReviewerEmailTitle,
					notify_recipient_email_digest_title: this.notifyOptionsPopup.notifyRecipientEmailDigestTitle,
					notify_reviewer_email_digest_title: this.notifyOptionsPopup.notifyReviewerEmailDigestTitle,
				}
			}
		};

		this.notifyOptionsPopup.changeNotifyPeriodInProcess = true;

		this.rs.updateTpRules('', ruleData).then((response) => {
			this.mainRulePreset.notify_reviewer_periods = notifyReviewerPeriodsArr;
			this.mainRulePreset.notify_reviewer_daily_hour = notifyReviewerDailyHoursUTC.join(', ');
			this.mainRulePreset.notify_reviewer_days = selectedNotifyReviewerDays;
			this.mainRulePreset.notify_recipient_periods = notifyRecipientPeriodsArr;
			this.mainRulePreset.notify_recipient_daily_hour = notifyRecipientDailyHoursUTC.join(', ');
			this.mainRulePreset.notify_recipient_days = selectedNotifyRecipientDays;
			this.mainRulePreset.notify_recipient_period_text = this.notifyOptionsPopup.notifyRecipientPeriodText;
			this.mainRulePreset.notify_recipient_allow_request_release = this.notifyOptionsPopup.notifyRecipientAllowRequestRelease;
			this.mainRulePreset.recipient_request_release_reason_mandatory = this.notifyOptionsPopup.requireRecipientReleaseRequestReason;
			this.mainRulePreset.notify_recipient_allow_request_release_email = this.notifyOptionsPopup.notifyRecipientAllowRequestReleaseEmail;
			this.mainRulePreset.notify_recipient_allow_request_release_email_change_from = this.notifyOptionsPopup.notifyRecipientAllowRequestReleaseFrom;
			this.mainRulePreset.notify_recipient_allow_change_time = this.notifyOptionsPopup.notifyRecipientAllowChangeTime;
			this.mainRulePreset.notify_release_request_subject = this.notifyOptionsPopup.notifyRecipientAllowRequestSubject;
			this.mainRulePreset.notify_recipient_show_link_to_webapp = this.notifyOptionsPopup.notifyRecipientShowLinkToWebapp;
			this.mainRulePreset.notify_recipient_show_tag_info = this.notifyOptionsPopup.notifyRecipientShowTagInfo;
			this.mainRulePreset.notify_reply_to = this.notifyOptionsPopup.notifyReplyToEmail;
			this.mainRulePreset.notify_recipient_email_title = this.notifyOptionsPopup.notifyRecipientEmailTitle;
			this.mainRulePreset.notify_reviewer_email_title = this.notifyOptionsPopup.notifyReviewerEmailTitle;
			this.mainRulePreset.notify_recipient_email_digest_title = this.notifyOptionsPopup.notifyRecipientEmailDigestTitle;
			this.mainRulePreset.notify_reviewer_email_digest_title = this.notifyOptionsPopup.notifyReviewerEmailDigestTitle;
			this.notifyOptionsPopup = null;
			this.closeCb.emit();
		}, (err) => {
			if (err?.data?.message) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.notifyOptionsPopup.changeNotifyPeriodInProcess = false;
		});
	};

	toggleNotificationDailyHour = (listOfHours, targetHour) => {
		if (listOfHours.includes(targetHour)) {
			_.remove(listOfHours, hour => hour === targetHour);
		}
		else {
			listOfHours.push(targetHour);
		}
	}
}
